import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "M6.308 21.5q-.749 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278v-9.384q0-.748.53-1.278t1.278-.53H7.5v-2q0-1.873 1.313-3.186Q10.127 2 12 2t3.187 1.314T16.5 6.5v2h1.192q.749 0 1.278.53.53.53.53 1.278v9.384q0 .749-.53 1.278-.53.53-1.278.53zm0-1.5h11.384a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22v-9.385a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087H6.307a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v9.385a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087M12 16.75q.729 0 1.24-.51.51-.51.51-1.24 0-.729-.51-1.24-.511-.51-1.24-.51-.73 0-1.24.51-.51.511-.51 1.24 0 .73.51 1.24t1.24.51M9 8.5h6v-2q0-1.25-.875-2.125A2.9 2.9 0 0 0 12 3.5q-1.25 0-2.125.875A2.9 2.9 0 0 0 9 6.5z"
    }, null, -1)
  ])))
}
export default { render: render }